import { render, staticRenderFns } from "./ReportDamageNotice.vue?vue&type=template&id=0f5e4622&scoped=true"
import script from "./ReportDamageNotice.vue?vue&type=script&lang=ts"
export * from "./ReportDamageNotice.vue?vue&type=script&lang=ts"
import style0 from "./ReportDamageNotice.vue?vue&type=style&index=0&id=0f5e4622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5e4622",
  null
  
)

export default component.exports